import {LOCALES} from '../../../config';

export default () => LOCALES;
